const NavbarClassic = require('./NavbarClassic')

module.exports = NavbarClassic